$(function () {

    var gridMemberCommunication = $(".grid-member-communication-item");
    var i;

    for (i = 0; i < gridMemberCommunication.length; i++) {
        gridMemberCommunication[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }


    $('.mobile-navigation-items > .navigation-list').on('click', '.main-item-mobile, div', function (event) {
        var $top = $('.level-0');
        var $target = $(event.target);
        if ($target.is('.main-item-mobile') || $target.is('div')) {
            $(this).addClass('open');
            $(this).siblings('li').hide();
            $(this).find('.main-item-link').hide();
            $(this).find('.level-1').show();
        }
    });

    $('.go-back').on('click', function () {

        $(this).parent('ul').parent('li').removeClass('open');
        $(this).parent('ul').hide();
        $(this).parent('ul').prev().show();
        $(this).parent('ul').parent('li').siblings('li').show();
    });

    $('.mobile-trigger').on('click', function () {
        $('body').toggleClass('overflow-hidden');
    });


    //sidebar
    $('.sidenav-button').on('click', function (e) {
        var closestparent = $(this).closest('.sidebar-navigation-item-parent');
        var closestparent2 = $(this).closest('.sidebar-navigation-item');

        var siblings = (closestparent2.siblings());
        console.log(siblings)
        //Remove active class on all buttons

        if (closestparent.hasClass('active-sidebaritem')) {
            closestparent.removeClass('active-sidebaritem')
        } else {
            closestparent.addClass('active-sidebaritem');
            siblings.each(function (index) {
                $(this).children('.sidebar-navigation-item-parent').removeClass('active-sidebaritem');
            }
            )
        }

    })


    // Sticky Scroll
    var quickLinks = $('.summary-menu');
    if (quickLinks.length) {
        var offSetTop = quickLinks.offset().top;
        var paddingTop = quickLinks.outerHeight();
        var windowWidth = $(window).width();
        // console.log(windowWidth);
    }

    function fixedNav() {
        if (windowWidth < 991) {

            if (offSetTop <= window.scrollY) {
                $('body').css('padding-top', paddingTop);
                quickLinks.addClass('fixed-nav');
            } else {
                $('body').css('padding-top', '0');
                quickLinks.removeClass('fixed-nav');
            }
        }
    }

    window.addEventListener('scroll', fixedNav);

    // https://davidwalsh.name/javascript-debounce-function
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    // horizontal implementation only
    $('[data-overflow-checker]').each(function () {
        var $original = $(this);
        var $target = $($original.data('overflow-checker'));

        function check(event) {
            var element = this;
            var isOverflowing = element.scrollWidth > element.clientWidth;
            if (isOverflowing) {
                $original.addClass('overflowing');
            } else {
                $original.removeClass('overflowing');
            }
            var isAtVerticalScrollEnd = element.offsetWidth + element.scrollLeft >= element.scrollWidth;
            if (isAtVerticalScrollEnd) {
                $original.addClass('at-vertical-scroll-end');
            } else {
                $original.removeClass('at-vertical-scroll-end');
            }
        }

        if ($target.length === 1) {
            var boundCheck = check.bind($target[0]);
            $(window).on('resize', debounce(boundCheck, 100));
            $target.on('scroll', debounce(check, 50));
            boundCheck();
        }
    });

    (function () {

        // QuickLinks Menu
        var $longread = $('#longread-text');

        if ($longread.length === 0)
            return;

        var $quickLinkMenu = $('.quick-link-menu');

        if ($quickLinkMenu.length === 0)
            return;

        var $quickLinkMenuWrapper = $quickLinkMenu.parent();

        var offset = $('.navigation').outerHeight();


        if ($('.summary-menu').length) {
            var extraOffset = $('.grid-section').find('h2').length * 50 + 100;
            offset += extraOffset;
        }

        if ($('.active.has-sub-menu').length) {
            offset += $('.sub-menu').outerHeight();
        }

        if ($longread.length) {
            $longread.quickLinkMenu({
                target: $quickLinkMenu,
                itemSelector: 'h2',
                scrollTopOffset: offset
            });
            if ($quickLinkMenu.children().length) {
                $quickLinkMenu.removeClass('hide');

                var offset = $quickLinkMenuWrapper.offset();

                $('body').scrollspy({
                    target: '.quick-link-menu-wrapper',
                    offset: offset.top
                });

                var paddingBottom = parseInt($quickLinkMenu.css('padding-bottom').slice(0, -2));
                offset.bottom = $('#footer').outerHeight() + $quickLinkMenu.outerHeight() + (!isNaN(paddingBottom) ? paddingBottom : 0);


            }
        }
    })()

    if ($(".instagram-media").length) {
        var tag = document.createElement('script');
        tag.src = "//www.instagram.com/embed.js";
        tag.defer = true;
        tag.async = true;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    var $subNavBar = $('.sub-navbar__container');
    var $summaryMenu = $('.summary-menu');

    if ($subNavBar.length) {
        $summaryMenu.addClass('has-subnav');
    }

    // Support module
    function setSupportChannelWidth() {
        const supportChannel = $('.support-channel');

        if (supportChannel.length == 1) {
            supportChannel.addClass("flex-100");
        }
        else if (supportChannel.length == 3) {
            supportChannel.addClass("flex-30");
        } else {
            supportChannel.addClass("flex-50");
        }
    }

    setSupportChannelWidth();
});




